import { IBranchDto } from '../department/dtos';
import { IUserBranchDto, IUserDto } from './dtos';

export enum UserAccess {
  None = 'NONE',
  Regular = 'REGULAR',
  Admin = 'ADMIN',
}

export interface IBranch {
  id: string;
  name: string;
  access: UserAccess;
  countryCode: string;
  maxImageUploaded?: number;
  useUpperCase?: boolean;
  endUserInvoicing?: boolean;
  businessInvoicing?: boolean;
  locale: string;
  contactPersonId?: string;
  axCustomerId: string;
  _dto: IBranchDto;
}

export interface IUser {
  id: string;
  firstName: string;
  lastName: string;
  fullName: string;
  initials: string;
  email: string;
  visiblePrices: boolean;
  isInternalUser: boolean;
  branches: IBranch[];
  phoneNumber?: string;
  contactPersonId?: string;
  phone?: string;
  _dto: IUserDto;
}

export interface IUserBranchAccess {
  id: IUser['id'];
  fullName: IUser['fullName'];
  email: IUser['email'];
  phoneNumber: IUser['phoneNumber'];
  branchId: IBranch['axCustomerId'];
  currentBranchContactPersonId?: IUser['contactPersonId'];
  access: UserAccess;
  _dto: IUserBranchDto;
}

export interface IAddNewUserParams {
  email: IUser['email'];
  branches: {
    branchId: IBranch['id'];
    isAdmin: boolean;
  }[];
}

export interface IContactPerson {
  type: string;
  name: string;
  email?: string;
  phone?: string;
  phoneAlt?: string;
}

export interface IUserAccessChangeParams {
  userId: IUser['id'];
  branchId: IBranch['axCustomerId'];
  isAdmin?: boolean;
}

export interface IAcceptInviteParams {
  id: string;
  firstName: string;
  lastName: string;
  mobilePhone: string;
  password: string;
}

export interface IWatcher {
  id: string;
  email: string;
  contactPersonId: string;
  firstName?: string;
  lastName?: string;
}

export interface IUserSettings {
  showPrices?: boolean;
}

export interface IUpdateProfileParams {
  email?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  settings?: IUserSettings;
}
